export default "__VITE_ASSET__B751Yuvp__"